
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class UserLanguage extends Vue {
  @Prop(Object) user!: any;
  @Prop(Boolean) isEdit!: boolean;
  @Prop(Array) optionsEst!: any;
  @Prop(Array) optionsLang!: any;
  @Prop(Function) cancelButton!: any;
  @Prop(Function) saveLanguage!: any;
  languageError = [];

  @Watch("user.language")
  changeLang() {
    if (typeof this.user.language !== "object") {
      this.loadLanguage();
    }
  }
  loadLanguage() {
    if (this.user.language) {
      let num_id =
        typeof this.user.language === "object"
          ? this.user.language.id
          : parseInt(this.user.language);
      this.user.language = this.optionsLang.find((i: any) => {
        return i.external_id === num_id;
      });
    }
    if (this.user.writing_level) {
      let num_id =
        typeof this.user.writing_level === "object"
          ? this.user.writing_level.id
          : parseInt(this.user.writing_level);
      this.user.writing_level = this.optionsEst.find((i: any) => {
        return i.external_id === num_id;
      });
    }
  }

  mounted() {
    this.loadLanguage();
  }

  validateLang() {
    this.languageError = [];
    if ((this as any).user.language && (this as any).user.writing_level) {
      this.saveLanguage();
    }
    else {
      if (!(this as any).user.language) {
        (this as any).languageError.push('lang');
      }
      if (!(this as any).user.writing_level) {
        (this as any).languageError.push('lvl');
      }
    }
  }

  handleSelect(event: any, type: string) {
    if (!event) {
      if (type === 'lang') {
        (this as any).user.language = null;
      }
      else {
        (this as any).user.writing_level = null;
      }
    }
  }
}
